import { render, staticRenderFns } from "./PCRemoteLink.vue?vue&type=template&id=5473607f"
import script from "./PCRemoteLink.vue?vue&type=script&lang=js"
export * from "./PCRemoteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports